/* eslint-disable */
import { initialAbility } from "@/libs/acl/config";
import BaseService from "../../BaseService";

const { http } = BaseService();

// API

export function DonViGetList(postdata) {
  const data = { ...postdata };
  return http({
    url: "DonVi/get-list-dv-by-id",
    method: "post",
    data,
  });
}

export function GetTreeDVSD(id) {
  // const data = { ...postdata };
  return http({
    url: "DonVi/get-don-vi-su-dung/" + id,
    method: "get",
  });
}

export function GetTree() {
  // const data = { ...postdata };
  return http({
    url: "DonVi/GetTree",
    method: "get",
  });
}

export function GetTreeAll() {
  // const data = { ...postdata };
  return http({
    url: "DonVi/GetTreeAll",
    method: "get",
  });
}

export function GetTreeUserDonVi() {
  // const data = { ...postdata };
  return http({
    url: "DonVi/GetTreeExceptUserDonVi",
    method: "get",
  });
}

export function GetById(data) {
  return http({
    url: "DonVi/get-by-id/" + data,
    method: "get",
  });
}

export function DonViCreate(postdata) {
  const data = { ...postdata };
  return http({
    url: "DonVi/Create",
    method: "post",
    data,
  });
}

export function DonViUpdate(postdata) {
  const data = { ...postdata };
  return http({
    url: "DonVi/Update",
    method: "post",
    data,
  });
}

export function DonViDelete(postdata) {
  const data = { ...postdata };
  return http({
    url: "DonVi/Delete",
    method: "post",
    data,
  });
}

////////////////////////////////////////
